import './visual-editor.css';
import { useCallback as e, useEffect as t, useMemo as n, useRef as r, useState as i } from "react";
import { Fragment as a, jsx as o, jsxs as s } from "react/jsx-runtime";
//#region lib/core/_VisualEditorCore.ts
var c, l = "visual-editor", u = "TEXT_CHANGE_EVENT", d = "SET_TEXT_EVENT", f = "VISUAL_EDITOR_READY_EVENT", p = "SET_TEXT_STYLE_EVENT", m = class e {
	constructor(t) {
		this.id = l, this.onReady = (e) => (document.addEventListener(f, e), () => {
			document.removeEventListener(f, e);
		}), this.dispatchReadyEvent = (e) => {
			document.dispatchEvent(new CustomEvent(f, { detail: { id: e } }));
		}, this.getEditorElement = () => document.getElementById(this.id), this.dispatchTextChangeEvent = (e) => {
			document.dispatchEvent(new CustomEvent(u, { detail: e }));
		}, this.onTextChange = (e) => (document.addEventListener(u, e, { capture: !1 }), () => {
			document.removeEventListener(u, e);
		}), this.dispatchTextChangeEventById = (t) => (n) => {
			document.dispatchEvent(new CustomEvent(e._getEventNameById(u, t), { detail: {
				id: t,
				value: n
			} }));
		}, this.onTextChangeById = (t) => (n) => {
			let r = e._getEventNameById(u, t);
			return document.addEventListener(r, n), () => {
				document.removeEventListener(r, n);
			};
		}, this.setTextContentById = (t) => (n) => {
			document.dispatchEvent(new CustomEvent(e._getEventNameById(d, t), { detail: {
				id: t,
				value: n
			} }));
		}, this.onTextContentChangeById = (t) => (n) => {
			let r = e._getEventNameById(d, t);
			return document.addEventListener(r, n), () => {
				document.removeEventListener(r, n);
			};
		}, this.setTextStyleById = (t) => (n) => {
			document.dispatchEvent(new CustomEvent(e._getEventNameById(p, t), { detail: {
				id: t,
				renderProps: n
			} }));
		}, this.onTextStyleChangeById = (t) => (n) => {
			let r = e._getEventNameById(p, t);
			return document.addEventListener(r, n), () => {
				document.removeEventListener(r, n);
			};
		}, t && (this.id = t);
	}
};
c = m, c._instance = null, c.getInstance = (e) => (c._instance === null && (c._instance = new c(e)), c._instance), c._getEventNameById = (e, t) => [e, t].join("_");
//#endregion
//#region lib/core/constants.ts
var h = {
	TEXT: "TEXT",
	IMAGE: "IMAGE",
	EDITABLE_IMAGE: "EDITABLE_IMAGE",
	RECT: "RECT",
	LINE: "LINE",
	TO_LOCALE_STRING: "TO_LOCALE_STRING"
}, g = ({ children: e, width: t, height: n, id: r, instance: i, ...a }) => /* @__PURE__ */ s("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	x: 0,
	y: 0,
	viewBox: `0 0 ${t} ${n}`,
	id: r ?? "visual-editor",
	preserveAspectRatio: "xMinYMin meet",
	width: t,
	height: n,
	...a,
	children: [/* @__PURE__ */ o("style", { children: "\n        svg {\n          display: block;\n        }\n          \n        * {\n          text-orientation: upright;\n        }\n      " }), e]
});
//#endregion
//#region ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
function _(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) {
		var i = e.length;
		for (t = 0; t < i; t++) e[t] && (n = _(e[t])) && (r && (r += " "), r += n);
	} else for (n in e) e[n] && (r && (r += " "), r += n);
	return r;
}
function v() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = _(e)) && (r && (r += " "), r += t);
	return r;
}
var y = {
	svgImage: "_svgImage_hguya_1",
	imageWrapper: "_imageWrapper_hguya_11",
	image: "_image_hguya_11"
}, b = ({ id: e, readOnly: t, imgProps: n, UploadFileButton: r, hidden: i, position: a = "middle-center", ...s }) => {
	if (i) return null;
	let c = a.split("-");
	return /* @__PURE__ */ o("foreignObject", {
		x: "0",
		y: "0",
		width: "200",
		height: "200",
		id: e,
		...s,
		className: v(y.svgImage, s.className),
		"data-readonly": t,
		children: /* @__PURE__ */ o("div", {
			className: y.imageWrapper,
			...c && { "data-vertical-align": c[0] },
			...c && { "data-horizontal-align": c[1] },
			children: t || !r ? /* @__PURE__ */ o("img", {
				...n,
				className: v(y.image, n?.className)
			}) : r
		})
	});
}, x = (e) => /* @__PURE__ */ o("line", { ...e }), S = (e) => /* @__PURE__ */ o("rect", { ...e }), C = typeof global == "object" && global && global.Object === Object && global, w = typeof self == "object" && self && self.Object === Object && self, T = C || w || Function("return this")(), E = T.Symbol, D = Object.prototype, O = D.hasOwnProperty, ee = D.toString, k = E ? E.toStringTag : void 0;
function A(e) {
	var t = O.call(e, k), n = e[k];
	try {
		e[k] = void 0;
		var r = !0;
	} catch {}
	var i = ee.call(e);
	return r && (t ? e[k] = n : delete e[k]), i;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_objectToString.js
var te = Object.prototype.toString;
function j(e) {
	return te.call(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseGetTag.js
var ne = "[object Null]", M = "[object Undefined]", re = E ? E.toStringTag : void 0;
function N(e) {
	return e == null ? e === void 0 ? M : ne : re && re in Object(e) ? A(e) : j(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isObjectLike.js
function P(e) {
	return typeof e == "object" && !!e;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isSymbol.js
var ie = "[object Symbol]";
function ae(e) {
	return typeof e == "symbol" || P(e) && N(e) == ie;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayMap.js
function oe(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r;) i[n] = t(e[n], n, e);
	return i;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArray.js
var F = Array.isArray, se = Infinity, ce = E ? E.prototype : void 0, le = ce ? ce.toString : void 0;
function ue(e) {
	if (typeof e == "string") return e;
	if (F(e)) return oe(e, ue) + "";
	if (ae(e)) return le ? le.call(e) : "";
	var t = e + "";
	return t == "0" && 1 / e == -se ? "-0" : t;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_trimmedEndIndex.js
var de = /\s/;
function fe(e) {
	for (var t = e.length; t-- && de.test(e.charAt(t)););
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseTrim.js
var pe = /^\s+/;
function me(e) {
	return e && e.slice(0, fe(e) + 1).replace(pe, "");
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isObject.js
function I(e) {
	var t = typeof e;
	return e != null && (t == "object" || t == "function");
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toNumber.js
var he = NaN, ge = /^[-+]0x[0-9a-f]+$/i, _e = /^0b[01]+$/i, ve = /^0o[0-7]+$/i, ye = parseInt;
function be(e) {
	if (typeof e == "number") return e;
	if (ae(e)) return he;
	if (I(e)) {
		var t = typeof e.valueOf == "function" ? e.valueOf() : e;
		e = I(t) ? t + "" : t;
	}
	if (typeof e != "string") return e === 0 ? e : +e;
	e = me(e);
	var n = _e.test(e);
	return n || ve.test(e) ? ye(e.slice(2), n ? 2 : 8) : ge.test(e) ? he : +e;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isFunction.js
var xe = "[object AsyncFunction]", Se = "[object Function]", Ce = "[object GeneratorFunction]", we = "[object Proxy]";
function Te(e) {
	if (!I(e)) return !1;
	var t = N(e);
	return t == Se || t == Ce || t == xe || t == we;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_coreJsData.js
var Ee = T["__core-js_shared__"], De = function() {
	var e = /[^.]+$/.exec(Ee && Ee.keys && Ee.keys.IE_PROTO || "");
	return e ? "Symbol(src)_1." + e : "";
}();
function Oe(e) {
	return !!De && De in e;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_toSource.js
var ke = Function.prototype.toString;
function L(e) {
	if (e != null) {
		try {
			return ke.call(e);
		} catch {}
		try {
			return e + "";
		} catch {}
	}
	return "";
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsNative.js
var Ae = /[\\^$.*+?()[\]{}|]/g, je = /^\[object .+?Constructor\]$/, Me = Function.prototype, Ne = Object.prototype, Pe = Me.toString, Fe = Ne.hasOwnProperty, Ie = RegExp("^" + Pe.call(Fe).replace(Ae, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function Le(e) {
	return !I(e) || Oe(e) ? !1 : (Te(e) ? Ie : je).test(L(e));
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getValue.js
function Re(e, t) {
	return e?.[t];
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getNative.js
function R(e, t) {
	var n = Re(e, t);
	return Le(n) ? n : void 0;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_WeakMap.js
var ze = R(T, "WeakMap"), Be = Object.create, Ve = function() {
	function e() {}
	return function(t) {
		if (!I(t)) return {};
		if (Be) return Be(t);
		e.prototype = t;
		var n = new e();
		return e.prototype = void 0, n;
	};
}();
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_copyArray.js
function He(e, t) {
	var n = -1, r = e.length;
	for (t ||= Array(r); ++n < r;) t[n] = e[n];
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_defineProperty.js
var Ue = function() {
	try {
		var e = R(Object, "defineProperty");
		return e({}, "", {}), e;
	} catch {}
}();
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayEach.js
function We(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1;);
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isIndex.js
var Ge = 9007199254740991, Ke = /^(?:0|[1-9]\d*)$/;
function qe(e, t) {
	var n = typeof e;
	return t ??= Ge, !!t && (n == "number" || n != "symbol" && Ke.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseAssignValue.js
function Je(e, t, n) {
	t == "__proto__" && Ue ? Ue(e, t, {
		configurable: !0,
		enumerable: !0,
		value: n,
		writable: !0
	}) : e[t] = n;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/eq.js
function Ye(e, t) {
	return e === t || e !== e && t !== t;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_assignValue.js
var Xe = Object.prototype.hasOwnProperty;
function Ze(e, t, n) {
	var r = e[t];
	(!(Xe.call(e, t) && Ye(r, n)) || n === void 0 && !(t in e)) && Je(e, t, n);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_copyObject.js
function z(e, t, n, r) {
	var i = !n;
	n ||= {};
	for (var a = -1, o = t.length; ++a < o;) {
		var s = t[a], c = r ? r(n[s], e[s], s, n, e) : void 0;
		c === void 0 && (c = e[s]), i ? Je(n, s, c) : Ze(n, s, c);
	}
	return n;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isLength.js
var Qe = 9007199254740991;
function $e(e) {
	return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Qe;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArrayLike.js
function et(e) {
	return e != null && $e(e.length) && !Te(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isPrototype.js
var tt = Object.prototype;
function nt(e) {
	var t = e && e.constructor;
	return e === (typeof t == "function" && t.prototype || tt);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseTimes.js
function rt(e, t) {
	for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
	return r;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsArguments.js
var it = "[object Arguments]";
function at(e) {
	return P(e) && N(e) == it;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isArguments.js
var ot = Object.prototype, st = ot.hasOwnProperty, ct = ot.propertyIsEnumerable, lt = at(function() {
	return arguments;
}()) ? at : function(e) {
	return P(e) && st.call(e, "callee") && !ct.call(e, "callee");
};
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/stubFalse.js
function ut() {
	return !1;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isBuffer.js
var dt = typeof exports == "object" && exports && !exports.nodeType && exports, ft = dt && typeof module == "object" && module && !module.nodeType && module, pt = ft && ft.exports === dt ? T.Buffer : void 0, mt = (pt ? pt.isBuffer : void 0) || ut, ht = "[object Arguments]", gt = "[object Array]", _t = "[object Boolean]", vt = "[object Date]", yt = "[object Error]", bt = "[object Function]", xt = "[object Map]", St = "[object Number]", Ct = "[object Object]", wt = "[object RegExp]", Tt = "[object Set]", Et = "[object String]", Dt = "[object WeakMap]", Ot = "[object ArrayBuffer]", kt = "[object DataView]", At = "[object Float32Array]", jt = "[object Float64Array]", Mt = "[object Int8Array]", Nt = "[object Int16Array]", Pt = "[object Int32Array]", Ft = "[object Uint8Array]", It = "[object Uint8ClampedArray]", Lt = "[object Uint16Array]", Rt = "[object Uint32Array]", B = {};
B[At] = B[jt] = B[Mt] = B[Nt] = B[Pt] = B[Ft] = B[It] = B[Lt] = B[Rt] = !0, B[ht] = B[gt] = B[Ot] = B[_t] = B[kt] = B[vt] = B[yt] = B[bt] = B[xt] = B[St] = B[Ct] = B[wt] = B[Tt] = B[Et] = B[Dt] = !1;
function zt(e) {
	return P(e) && $e(e.length) && !!B[N(e)];
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseUnary.js
function Bt(e) {
	return function(t) {
		return e(t);
	};
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_nodeUtil.js
var Vt = typeof exports == "object" && exports && !exports.nodeType && exports, V = Vt && typeof module == "object" && module && !module.nodeType && module, Ht = V && V.exports === Vt && C.process, H = function() {
	try {
		return V && V.require && V.require("util").types || Ht && Ht.binding && Ht.binding("util");
	} catch {}
}(), Ut = H && H.isTypedArray, Wt = Ut ? Bt(Ut) : zt, Gt = Object.prototype.hasOwnProperty;
function Kt(e, t) {
	var n = F(e), r = !n && lt(e), i = !n && !r && mt(e), a = !n && !r && !i && Wt(e), o = n || r || i || a, s = o ? rt(e.length, String) : [], c = s.length;
	for (var l in e) (t || Gt.call(e, l)) && !(o && (l == "length" || i && (l == "offset" || l == "parent") || a && (l == "buffer" || l == "byteLength" || l == "byteOffset") || qe(l, c))) && s.push(l);
	return s;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_overArg.js
function qt(e, t) {
	return function(n) {
		return e(t(n));
	};
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_nativeKeys.js
var Jt = qt(Object.keys, Object), Yt = Object.prototype.hasOwnProperty;
function Xt(e) {
	if (!nt(e)) return Jt(e);
	var t = [];
	for (var n in Object(e)) Yt.call(e, n) && n != "constructor" && t.push(n);
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/keys.js
function Zt(e) {
	return et(e) ? Kt(e) : Xt(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_nativeKeysIn.js
function Qt(e) {
	var t = [];
	if (e != null) for (var n in Object(e)) t.push(n);
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseKeysIn.js
var $t = Object.prototype.hasOwnProperty;
function en(e) {
	if (!I(e)) return Qt(e);
	var t = nt(e), n = [];
	for (var r in e) r == "constructor" && (t || !$t.call(e, r)) || n.push(r);
	return n;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/keysIn.js
function tn(e) {
	return et(e) ? Kt(e, !0) : en(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_nativeCreate.js
var U = R(Object, "create");
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hashClear.js
function nn() {
	this.__data__ = U ? U(null) : {}, this.size = 0;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hashDelete.js
function rn(e) {
	var t = this.has(e) && delete this.__data__[e];
	return this.size -= t ? 1 : 0, t;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hashGet.js
var an = "__lodash_hash_undefined__", on = Object.prototype.hasOwnProperty;
function sn(e) {
	var t = this.__data__;
	if (U) {
		var n = t[e];
		return n === an ? void 0 : n;
	}
	return on.call(t, e) ? t[e] : void 0;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hashHas.js
var cn = Object.prototype.hasOwnProperty;
function ln(e) {
	var t = this.__data__;
	return U ? t[e] !== void 0 : cn.call(t, e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_hashSet.js
var un = "__lodash_hash_undefined__";
function dn(e, t) {
	var n = this.__data__;
	return this.size += this.has(e) ? 0 : 1, n[e] = U && t === void 0 ? un : t, this;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Hash.js
function W(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
W.prototype.clear = nn, W.prototype.delete = rn, W.prototype.get = sn, W.prototype.has = ln, W.prototype.set = dn;
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_listCacheClear.js
function fn() {
	this.__data__ = [], this.size = 0;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_assocIndexOf.js
function G(e, t) {
	for (var n = e.length; n--;) if (Ye(e[n][0], t)) return n;
	return -1;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_listCacheDelete.js
var pn = Array.prototype.splice;
function mn(e) {
	var t = this.__data__, n = G(t, e);
	return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : pn.call(t, n, 1), --this.size, !0);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_listCacheGet.js
function hn(e) {
	var t = this.__data__, n = G(t, e);
	return n < 0 ? void 0 : t[n][1];
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_listCacheHas.js
function gn(e) {
	return G(this.__data__, e) > -1;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_listCacheSet.js
function _n(e, t) {
	var n = this.__data__, r = G(n, e);
	return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_ListCache.js
function K(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
K.prototype.clear = fn, K.prototype.delete = mn, K.prototype.get = hn, K.prototype.has = gn, K.prototype.set = _n;
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Map.js
var q = R(T, "Map");
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheClear.js
function vn() {
	this.size = 0, this.__data__ = {
		hash: new W(),
		map: new (q || K)(),
		string: new W()
	};
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_isKeyable.js
function yn(e) {
	var t = typeof e;
	return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getMapData.js
function J(e, t) {
	var n = e.__data__;
	return yn(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheDelete.js
function bn(e) {
	var t = J(this, e).delete(e);
	return this.size -= t ? 1 : 0, t;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheGet.js
function xn(e) {
	return J(this, e).get(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheHas.js
function Sn(e) {
	return J(this, e).has(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_mapCacheSet.js
function Cn(e, t) {
	var n = J(this, e), r = n.size;
	return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_MapCache.js
function Y(e) {
	var t = -1, n = e == null ? 0 : e.length;
	for (this.clear(); ++t < n;) {
		var r = e[t];
		this.set(r[0], r[1]);
	}
}
Y.prototype.clear = vn, Y.prototype.delete = bn, Y.prototype.get = xn, Y.prototype.has = Sn, Y.prototype.set = Cn;
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/toString.js
function wn(e) {
	return e == null ? "" : ue(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayPush.js
function Tn(e, t) {
	for (var n = -1, r = t.length, i = e.length; ++n < r;) e[i + n] = t[n];
	return e;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getPrototype.js
var En = qt(Object.getPrototypeOf, Object);
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stackClear.js
function Dn() {
	this.__data__ = new K(), this.size = 0;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stackDelete.js
function On(e) {
	var t = this.__data__, n = t.delete(e);
	return this.size = t.size, n;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stackGet.js
function kn(e) {
	return this.__data__.get(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stackHas.js
function An(e) {
	return this.__data__.has(e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_stackSet.js
var jn = 200;
function Mn(e, t) {
	var n = this.__data__;
	if (n instanceof K) {
		var r = n.__data__;
		if (!q || r.length < jn - 1) return r.push([e, t]), this.size = ++n.size, this;
		n = this.__data__ = new Y(r);
	}
	return n.set(e, t), this.size = n.size, this;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Stack.js
function X(e) {
	this.size = (this.__data__ = new K(e)).size;
}
X.prototype.clear = Dn, X.prototype.delete = On, X.prototype.get = kn, X.prototype.has = An, X.prototype.set = Mn;
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseAssign.js
function Nn(e, t) {
	return e && z(t, Zt(t), e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseAssignIn.js
function Pn(e, t) {
	return e && z(t, tn(t), e);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_cloneBuffer.js
var Fn = typeof exports == "object" && exports && !exports.nodeType && exports, In = Fn && typeof module == "object" && module && !module.nodeType && module, Ln = In && In.exports === Fn ? T.Buffer : void 0, Rn = Ln ? Ln.allocUnsafe : void 0;
function zn(e, t) {
	if (t) return e.slice();
	var n = e.length, r = Rn ? Rn(n) : new e.constructor(n);
	return e.copy(r), r;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_arrayFilter.js
function Bn(e, t) {
	for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r;) {
		var o = e[n];
		t(o, n, e) && (a[i++] = o);
	}
	return a;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/stubArray.js
function Vn() {
	return [];
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getSymbols.js
var Hn = Object.prototype.propertyIsEnumerable, Un = Object.getOwnPropertySymbols, Wn = Un ? function(e) {
	return e == null ? [] : (e = Object(e), Bn(Un(e), function(t) {
		return Hn.call(e, t);
	}));
} : Vn;
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_copySymbols.js
function Gn(e, t) {
	return z(e, Wn(e), t);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getSymbolsIn.js
var Kn = Object.getOwnPropertySymbols ? function(e) {
	for (var t = []; e;) Tn(t, Wn(e)), e = En(e);
	return t;
} : Vn;
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_copySymbolsIn.js
function qn(e, t) {
	return z(e, Kn(e), t);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseGetAllKeys.js
function Jn(e, t, n) {
	var r = t(e);
	return F(e) ? r : Tn(r, n(e));
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getAllKeys.js
function Yn(e) {
	return Jn(e, Zt, Wn);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_getAllKeysIn.js
function Xn(e) {
	return Jn(e, tn, Kn);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_DataView.js
var Zn = R(T, "DataView"), Qn = R(T, "Promise"), $n = R(T, "Set"), er = "[object Map]", tr = "[object Object]", nr = "[object Promise]", rr = "[object Set]", ir = "[object WeakMap]", ar = "[object DataView]", or = L(Zn), sr = L(q), cr = L(Qn), lr = L($n), ur = L(ze), Z = N;
(Zn && Z(new Zn(/* @__PURE__ */ new ArrayBuffer(1))) != ar || q && Z(new q()) != er || Qn && Z(Qn.resolve()) != nr || $n && Z(new $n()) != rr || ze && Z(new ze()) != ir) && (Z = function(e) {
	var t = N(e), n = t == tr ? e.constructor : void 0, r = n ? L(n) : "";
	if (r) switch (r) {
		case or: return ar;
		case sr: return er;
		case cr: return nr;
		case lr: return rr;
		case ur: return ir;
	}
	return t;
});
var dr = Z, fr = Object.prototype.hasOwnProperty;
function pr(e) {
	var t = e.length, n = new e.constructor(t);
	return t && typeof e[0] == "string" && fr.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_Uint8Array.js
var mr = T.Uint8Array;
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_cloneArrayBuffer.js
function hr(e) {
	var t = new e.constructor(e.byteLength);
	return new mr(t).set(new mr(e)), t;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_cloneDataView.js
function gr(e, t) {
	var n = t ? hr(e.buffer) : e.buffer;
	return new e.constructor(n, e.byteOffset, e.byteLength);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_cloneRegExp.js
var _r = /\w*$/;
function vr(e) {
	var t = new e.constructor(e.source, _r.exec(e));
	return t.lastIndex = e.lastIndex, t;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_cloneSymbol.js
var yr = E ? E.prototype : void 0, br = yr ? yr.valueOf : void 0;
function xr(e) {
	return br ? Object(br.call(e)) : {};
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_cloneTypedArray.js
function Sr(e, t) {
	var n = t ? hr(e.buffer) : e.buffer;
	return new e.constructor(n, e.byteOffset, e.length);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_initCloneByTag.js
var Cr = "[object Boolean]", wr = "[object Date]", Tr = "[object Map]", Er = "[object Number]", Dr = "[object RegExp]", Or = "[object Set]", kr = "[object String]", Ar = "[object Symbol]", jr = "[object ArrayBuffer]", Mr = "[object DataView]", Nr = "[object Float32Array]", Pr = "[object Float64Array]", Fr = "[object Int8Array]", Ir = "[object Int16Array]", Lr = "[object Int32Array]", Rr = "[object Uint8Array]", zr = "[object Uint8ClampedArray]", Br = "[object Uint16Array]", Vr = "[object Uint32Array]";
function Hr(e, t, n) {
	var r = e.constructor;
	switch (t) {
		case jr: return hr(e);
		case Cr:
		case wr: return new r(+e);
		case Mr: return gr(e, n);
		case Nr:
		case Pr:
		case Fr:
		case Ir:
		case Lr:
		case Rr:
		case zr:
		case Br:
		case Vr: return Sr(e, n);
		case Tr: return new r();
		case Er:
		case kr: return new r(e);
		case Dr: return vr(e);
		case Or: return new r();
		case Ar: return xr(e);
	}
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_initCloneObject.js
function Ur(e) {
	return typeof e.constructor == "function" && !nt(e) ? Ve(En(e)) : {};
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/_baseIsMap.js
var Wr = "[object Map]";
function Gr(e) {
	return P(e) && dr(e) == Wr;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isMap.js
var Kr = H && H.isMap, qr = Kr ? Bt(Kr) : Gr, Jr = "[object Set]";
function Yr(e) {
	return P(e) && dr(e) == Jr;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/isSet.js
var Xr = H && H.isSet, Zr = Xr ? Bt(Xr) : Yr, Qr = 1, $r = 2, ei = 4, ti = "[object Arguments]", ni = "[object Array]", ri = "[object Boolean]", ii = "[object Date]", ai = "[object Error]", oi = "[object Function]", si = "[object GeneratorFunction]", ci = "[object Map]", li = "[object Number]", ui = "[object Object]", di = "[object RegExp]", fi = "[object Set]", pi = "[object String]", mi = "[object Symbol]", hi = "[object WeakMap]", gi = "[object ArrayBuffer]", _i = "[object DataView]", vi = "[object Float32Array]", yi = "[object Float64Array]", bi = "[object Int8Array]", xi = "[object Int16Array]", Si = "[object Int32Array]", Ci = "[object Uint8Array]", wi = "[object Uint8ClampedArray]", Ti = "[object Uint16Array]", Ei = "[object Uint32Array]", Q = {};
Q[ti] = Q[ni] = Q[gi] = Q[_i] = Q[ri] = Q[ii] = Q[vi] = Q[yi] = Q[bi] = Q[xi] = Q[Si] = Q[ci] = Q[li] = Q[ui] = Q[di] = Q[fi] = Q[pi] = Q[mi] = Q[Ci] = Q[wi] = Q[Ti] = Q[Ei] = !0, Q[ai] = Q[oi] = Q[hi] = !1;
function $(e, t, n, r, i, a) {
	var o, s = t & Qr, c = t & $r, l = t & ei;
	if (n && (o = i ? n(e, r, i, a) : n(e)), o !== void 0) return o;
	if (!I(e)) return e;
	var u = F(e);
	if (u) {
		if (o = pr(e), !s) return He(e, o);
	} else {
		var d = dr(e), f = d == oi || d == si;
		if (mt(e)) return zn(e, s);
		if (d == ui || d == ti || f && !i) {
			if (o = c || f ? {} : Ur(e), !s) return c ? qn(e, Pn(o, e)) : Gn(e, Nn(o, e));
		} else {
			if (!Q[d]) return i ? e : {};
			o = Hr(e, d, s);
		}
	}
	a ||= new X();
	var p = a.get(e);
	if (p) return p;
	a.set(e, o), Zr(e) ? e.forEach(function(r) {
		o.add($(r, t, n, r, e, a));
	}) : qr(e) && e.forEach(function(r, i) {
		o.set(i, $(r, t, n, i, e, a));
	});
	var m = u ? void 0 : (l ? c ? Xn : Yn : c ? tn : Zt)(e);
	return We(m || e, function(r, i) {
		m && (i = r, r = e[i]), Ze(o, i, $(r, t, n, i, e, a));
	}), o;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/cloneDeep.js
var Di = 1, Oi = 4;
function ki(e) {
	return $(e, Di | Oi);
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/now.js
var Ai = function() {
	return T.Date.now();
}, ji = "Expected a function", Mi = Math.max, Ni = Math.min;
function Pi(e, t, n) {
	var r, i, a, o, s, c, l = 0, u = !1, d = !1, f = !0;
	if (typeof e != "function") throw TypeError(ji);
	t = be(t) || 0, I(n) && (u = !!n.leading, d = "maxWait" in n, a = d ? Mi(be(n.maxWait) || 0, t) : a, f = "trailing" in n ? !!n.trailing : f);
	function p(t) {
		var n = r, a = i;
		return r = i = void 0, l = t, o = e.apply(a, n), o;
	}
	function m(e) {
		return l = e, s = setTimeout(_, t), u ? p(e) : o;
	}
	function h(e) {
		var n = e - c, r = e - l, i = t - n;
		return d ? Ni(i, a - r) : i;
	}
	function g(e) {
		var n = e - c, r = e - l;
		return c === void 0 || n >= t || n < 0 || d && r >= a;
	}
	function _() {
		var e = Ai();
		if (g(e)) return v(e);
		s = setTimeout(_, h(e));
	}
	function v(e) {
		return s = void 0, f && r ? p(e) : (r = i = void 0, o);
	}
	function y() {
		s !== void 0 && clearTimeout(s), l = 0, r = c = i = s = void 0;
	}
	function b() {
		return s === void 0 ? o : v(Ai());
	}
	function x() {
		var e = Ai(), n = g(e);
		if (r = arguments, i = this, c = e, n) {
			if (s === void 0) return m(c);
			if (d) return clearTimeout(s), s = setTimeout(_, t), p(c);
		}
		return s === void 0 && (s = setTimeout(_, t)), o;
	}
	return x.cancel = y, x.flush = b, x;
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/throttle.js
var Fi = "Expected a function";
function Ii(e, t, n) {
	var r = !0, i = !0;
	if (typeof e != "function") throw TypeError(Fi);
	return I(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), Pi(e, t, {
		leading: r,
		maxWait: t,
		trailing: i
	});
}
//#endregion
//#region ../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/uniqueId.js
var Li = 0;
function Ri(e) {
	var t = ++Li;
	return wn(e) + t;
}
//#endregion
//#region lib/ui/components/_SVGText.tsx
function zi({ id: c = Ri(), readOnly: l = !1, disabled: u = !1, defaultValue: d, renderProps: f, onClick: p, onFocus: h, onBlur: g, onReady: _, onInput: y, opts: b, hidden: x }) {
	let S = r(null), C = r(null), w = r(null), T = r(null), E = r(null), D = r(null), [O, ee] = i(!1), k = m.getInstance(), [A, te] = i(f), j = n(() => A?.position ?? "center", [A.position]), ne = ki(b?.foreignObjectProps || {}), M = e(Ii(() => {
		if (!S.current || !T.current || !E.current || !D.current || !w.current) return;
		let e = E.current.innerHTML === "&nbsp;" || E.current.innerHTML === "<br>" || E.current.innerHTML === "" || E.current.innerHTML === " ", t = E.current.getBBox(), n = t.width, r = t.height, i = e ? 0 : n + (A?.px ?? 0) * 2, a = e ? A.height ? A.height + (A?.py ?? 0) * 2 : 0 : r + (A?.py ?? 0) * 2, o = (a - r) / 2;
		T.current.setAttribute("viewBox", `0 0 ${i} ${a}`), T.current.setAttribute("height", `${a}`), D.current.setAttribute("width", `${i}`), D.current.setAttribute("height", `${a}`), E.current.setAttribute("y", `${o}`), w.current.setAttribute("height", `${a}`), S.current.setAttribute("height", `${a}`);
		let s = a - (A.height ?? 0);
		if (s > 0) {
			let [e] = j.split("-"), t = () => {
				let t = Number(A?.y ?? 0);
				switch (e) {
					case "bottom": return t - Number(s);
					case "top": return t;
					case "center": return t - Number(s) / 2;
					default: return t;
				}
			};
			if (S.current) {
				let e = t();
				S.current.setAttribute("y", e.toString());
			}
		}
	}, 100, {
		leading: !0,
		trailing: !0
	}), [A]);
	return t(() => {
		document.fonts.ready.then(() => {
			ee(!0), k.dispatchReadyEvent(c);
		});
	}, []), t(() => {
		if (O) {
			if (E.current) {
				let e = d ? d.replace(/^\s+|\s+$/g, "") : "";
				E.current.innerHTML = e === "" ? "&nbsp;" : e, k.dispatchTextChangeEvent({
					value: e,
					id: c
				}), k.dispatchTextChangeEventById(c)(e);
			}
			M(), window.requestAnimationFrame(() => {
				window.setTimeout(() => {
					_?.();
				}, 500);
			});
		}
	}, [O]), t(() => {
		let e = Ii(k.onTextContentChangeById(c)((e) => {
			if (C && document.activeElement !== C?.current && E.current) {
				let t = e.detail.value.replace(/^\s+|\s+$/g, "");
				E.current && (E.current.innerHTML = t === "" ? "&nbsp;" : t), M();
			}
		}), 100, {
			leading: !0,
			trailing: !0
		});
		return () => {
			e?.();
		};
	}, [
		c,
		E.current,
		k,
		A
	]), t(() => {
		let e = k.onTextStyleChangeById(c)((e) => {
			te((t) => ({
				...t,
				...e.detail.renderProps
			}));
		});
		return () => {
			e?.();
		};
	}, [c, k]), t(() => {
		M(), setTimeout(() => {
			M();
		}, 200);
	}, [A]), t(() => {
		let e = new MutationObserver((e) => {
			e.forEach((e) => {
				e.type === "characterData" && e.target instanceof Text ? (k.dispatchTextChangeEvent({
					value: e.target.data,
					id: c
				}), k.dispatchTextChangeEventById(c)(e.target.data)) : e.type === "childList" && e.target === E.current && e.addedNodes.length === 1 && e.addedNodes[0] instanceof HTMLBRElement && E.current?.innerHTML.includes("<br>") && (E.current.innerHTML = E.current.innerHTML.replace(/<br>/, "&nbsp;")), M();
			});
		});
		return E.current && e.observe(E.current, {
			attributes: !1,
			characterData: !0,
			childList: !0,
			subtree: !0
		}), () => {
			e.disconnect();
		};
	}, []), x ? null : /* @__PURE__ */ o("foreignObject", {
		id: c,
		"data-readonly": !!l,
		"data-disabled": !!u,
		"data-component": "visual-editor-foreign-object",
		ref: S,
		className: v("visual-editor-foreign-object"),
		x: A?.x,
		y: A?.y,
		width: A?.maxWidth,
		height: A?.height,
		transform: A?.transform,
		onClick: (e) => {
			u || C.current?.focus(), b?.foreignObjectProps?.onClick?.(e);
		},
		...ne,
		children: /* @__PURE__ */ o("div", {
			ref: C,
			style: {
				height: "100%",
				opacity: O ? 1 : 0
			},
			className: "visual-editor-contenteditable-container",
			suppressContentEditableWarning: !0,
			contentEditable: !(u || l),
			onKeyDown: (e) => {
				e.key === "Enter" && e.preventDefault();
			},
			onBlur: (e) => {
				if (g?.(e), u || l) {
					e.preventDefault();
					return;
				}
				if (!E.current) return;
				let t = E.current?.firstChild;
				if (t) {
					let e = t.data.replace(/^\s+|\s+$/g, "");
					e.length > 0 && (k.dispatchTextChangeEvent({
						value: e,
						id: c
					}), k.dispatchTextChangeEventById(c)(e));
				}
			},
			onBeforeInput: (e) => {
				(u || l) && e.preventDefault();
			},
			onClick: (e) => {
				if (u) {
					e.preventDefault();
					return;
				}
				E.current?.focus(), p?.(e);
			},
			onInput: (e) => {
				y?.(e);
			},
			onFocus: (e) => {
				if (u) {
					e.preventDefault();
					return;
				}
				h?.(e);
			},
			children: /* @__PURE__ */ o("svg", {
				xmlns: "http://www.w3.org/2000/svg",
				fill: "currentColor",
				className: "visual-editor-outer-svg",
				ref: w,
				x: A?.x,
				y: A?.y,
				width: A?.maxWidth,
				height: A?.height,
				preserveAspectRatio: Bi[j],
				...b?.svgProps,
				children: /* @__PURE__ */ s("svg", {
					ref: T,
					className: "visual-editor-inner-svg",
					preserveAspectRatio: Bi[j],
					children: [
						A.writingMode && /* @__PURE__ */ o("style", { children: `
            #${c} .visual-editor-text {
              writing-mode: ${A.writingMode};
              ${A.writingMode === "vertical-lr" && "transform: translate(100%);"}
            }
          ` }),
						/* @__PURE__ */ o("rect", {
							ref: D,
							x: "0",
							y: "0",
							rx: A?.rx,
							fill: A?.fill ?? "none",
							...b?.textContainerRectProps
						}),
						/* @__PURE__ */ o("text", {
							ref: E,
							x: A?.px ? A.px : 0,
							y: A?.py ? A.py : 0,
							alignmentBaseline: "text-before-edge",
							className: "visual-editor-text",
							fontSize: A?.fontSize,
							fontFamily: A?.fontFamily,
							fill: A?.fontColor,
							...b?.textProps,
							style: { textRendering: "geometricPrecision" },
							children: !d || d === "<br>" || d === "" ? /* @__PURE__ */ o(a, { children: "\xA0" }) : d.replace(/\s/g, "")
						})
					]
				})
			})
		})
	}, c);
}
var Bi = {
	center: "xMidYMid meet",
	"bottom-left": "xMinYMax meet",
	"bottom-right": "xMaxYMax meet",
	"bottom-center": "xMidYMax meet",
	"top-left": "xMinYMin meet",
	"top-right": "xMaxYMin meet",
	"top-center": "xMidYMin meet",
	"center-left": "xMinYMid meet",
	"center-right": "xMaxYMid meet"
};
//#endregion
//#region lib/ui/components/_SVGToLocaleString.tsx
function Vi({ defaultValue: e, prefixValue: t, suffixValue: n, ...r }) {
	return /* @__PURE__ */ o(zi, {
		defaultValue: e ? `${t || ""}${e.toLocaleString()}${n || ""}` : "",
		...r
	});
}
//#endregion
//#region lib/ui/_VisualEditor.tsx
var Hi = ({ svgWidth: e, svgHeight: n, fontFaces: i, data: a, readOnly: c, svgProps: l, onReady: u, onError: d }) => {
	let f = r(0), p = r(0), m = () => {
		f.current += 1, f.current === p.current && window.requestAnimationFrame(() => {
			window.setTimeout(() => {
				u?.();
			}, 0);
		});
	};
	return t(() => {
		let e = a?.reduce((e, t) => (t.type === h.TEXT && e.textCount++, t.type === h.IMAGE && e.imageCount++, e), {
			textCount: 0,
			imageCount: 0
		}) ?? {
			textCount: 0,
			imageCount: 0
		};
		p.current = e.textCount + e.imageCount;
	}, [a]), /* @__PURE__ */ s(g, {
		viewBox: `0 0 ${e} ${n}`,
		width: "100%",
		height: "100%",
		preserveAspectRatio: "xMaxYMax meet",
		...l,
		children: [/* @__PURE__ */ o("style", { children: i }), a?.sort((e, t) => (e.order === void 0 ? -Infinity : e.order) - (t.order === void 0 ? -Infinity : t.order)).map((e, t) => {
			if (e.type === h.TEXT) return /* @__PURE__ */ o(zi, {
				...e.props,
				id: e.id,
				readOnly: e.props.readOnly || c,
				onReady: m
			}, t);
			if (e.type === h.IMAGE) return /* @__PURE__ */ o("image", {
				...e.props,
				id: e.id,
				onLoad: m,
				onError: d
			}, t);
			if (e.type === h.EDITABLE_IMAGE) return /* @__PURE__ */ o(b, {
				...e.props,
				id: e.id,
				readOnly: e.props.readOnly || c
			}, t);
			if (e.type === h.RECT) return /* @__PURE__ */ o(S, {
				...e.props,
				id: e.id
			}, t);
			if (e.type === h.LINE) return /* @__PURE__ */ o(x, {
				...e.props,
				id: e.id
			}, t);
			if (e.type === h.TO_LOCALE_STRING) return /* @__PURE__ */ o(Vi, {
				...e.props,
				id: e.id
			}, t);
		})]
	});
};
//#endregion
//#region lib/core/hooks/useVisualEditor.tsx
function Ui(e) {
	return {
		VisualEditorCore: m.getInstance(e),
		VisualEditor: Hi
	};
}
//#endregion
export { h as COMPONENT_TYPE, l as VISUAL_EDITOR_ID, Ui as useVisualEditor };
